/**
 * Produktsida Atelier — sticky buy reparent, mobile fade, unified panel tabs,
 * store card/sheet helpers, quantity.
 */
(function () {
  var MQ = window.matchMedia('(max-width: 61.99em)');

  function qs(root, sel) {
    return (root || document).querySelector(sel);
  }

  function qsa(root, sel) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  /* —— Buy block reparent (mobile sticky stage / lift) —— */
  function placeBuyBlock(root) {
    var buy = qs(root, '[data-atelier-buy]');
    var sticky = qs(root, '[data-atelier-sticky]');
    var lift = sticky && qs(sticky, '[data-atelier-sticky-lift]');
    var mobileHost = lift || sticky;
    var slot = qs(root, '[data-atelier-buy-slot]');
    if (!buy || !sticky || !slot) return;
    if (MQ.matches) {
      if (mobileHost && buy.parentElement !== mobileHost) mobileHost.appendChild(buy);
    } else if (buy.parentElement !== slot) {
      slot.appendChild(buy);
    }
  }

  /*
   * Lock sticky pin to px from the small viewport (svh).
   * Avoids mid-scroll jumps when mobile browser chrome toggles and vh/dvh change.
   * Re-lock only on orientation / explicit layout — not every URL-bar resize.
   */
  function lockPinOffset(root) {
    var sticky = qs(root, '[data-atelier-sticky]');
    if (!sticky) return;
    if (!MQ.matches) {
      sticky.style.removeProperty('--atelier-pin-offset');
      return;
    }
    var h = window.innerHeight || 0;
    try {
      var probe = document.createElement('div');
      probe.setAttribute('aria-hidden', 'true');
      probe.style.cssText =
        'position:absolute;left:0;top:0;height:100svh;width:0;overflow:hidden;pointer-events:none;visibility:hidden;';
      document.documentElement.appendChild(probe);
      var svh = probe.offsetHeight;
      probe.remove();
      if (svh > 0) h = svh;
    } catch (err) {
      /* svh probe unsupported — keep innerHeight */
    }
    if (!(h > 0)) return;
    var offset = Math.round(h * 0.56);
    /*
     * Nicola Fasano-serier: serieremsan ligger sist i det fasta blocket. Låt blocket scrolla upp tills
     * remsan ligger överst, så att man ser och kan bläddra i den innan panelen glider upp (Anders 2026-10-24).
     */
    var remsa = sticky.querySelector('[data-serie-remsa]');
    if (remsa) {
      var remsaTop = remsa.getBoundingClientRect().top - sticky.getBoundingClientRect().top;
      offset = Math.max(offset, Math.round(remsaTop - 16));
    }
    sticky.style.setProperty('--atelier-pin-offset', '-' + offset + 'px');
  }

  /* —— Mobile Lemaire: delayed pin, shared dim veil (image + ATC), header away —— */
  function initStickyFade(root) {
    var sticky = qs(root, '[data-atelier-sticky]');
    var fade = qs(root, '[data-atelier-sticky-fade]');
    if (!sticky || !fade) return;
    if (sticky.getAttribute('data-fade-bound') === 'true') return;
    sticky.setAttribute('data-fade-bound', 'true');

    var header = document.querySelector('[data-tambur-header]');
    var headerContent = header && header.querySelector('[data-tambur-header-content]');
    var headerBackdrop = header && header.querySelector('[data-tambur-header-backdrop]');
    /* Dim ramp after pin delay — sheet should not grey out ATC while first block still rising. */
    var SCROLL_RANGE = 450;
    var DIM_OPACITY = 0.7;
    var HEADER_TOP = 2;
    var headerHidden = false;
    var REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function headerBar() {
      return (
        parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--tambur-header-bar-height')) ||
        48
      );
    }

    /* Match CSS --atelier-pin-offset so veil starts as sticky pins (buy near top). */
    function pinDelayPx() {
      var top = parseFloat(getComputedStyle(sticky).top);
      if (!isFinite(top)) return Math.round(window.innerHeight * 0.56);
      return Math.max(0, Math.round(-top));
    }

    function setHeaderOut(hide) {
      if (!header) return;
      if (headerHidden === hide) return;
      headerHidden = hide;
      document.body.classList.toggle('tambur-atelier-lemaire-scroll', hide);
      if (hide) {
        var barH = headerBar();
        header.classList.remove('is-scroll-shooting--show');
        header.classList.add('is-scroll-shooting--hide');
        if (headerContent) headerContent.style.transform = 'translate3d(0,' + -barH + 'px,0)';
        if (headerBackdrop) headerBackdrop.style.transform = 'translate3d(0,' + -barH + 'px,0)';
      } else {
        header.classList.remove('is-scroll-shooting--hide');
        header.classList.add('is-scroll-shooting--show');
        if (headerContent) headerContent.style.transform = 'translate3d(0,0,0)';
        if (headerBackdrop) headerBackdrop.style.transform = 'translate3d(0,0,0)';
      }
    }

    function clearDesktop() {
      fade.style.opacity = '0';
      fade.style.pointerEvents = 'none';
      if (REDUCE) fade.style.transition = '';
      sticky.classList.remove('is-sheet-active');
      setHeaderOut(false);
    }

    function update() {
      if (!MQ.matches) {
        clearDesktop();
        return;
      }
      var y = window.scrollY || window.pageYOffset || 0;
      var delay = pinDelayPx();
      var progress = Math.min(1, Math.max(0, (y - delay) / SCROLL_RANGE));
      var opacity = Math.min(DIM_OPACITY, progress * DIM_OPACITY);
      /* Visual veil over gallery + Lägg i korg — never capture taps (ATC must stay clickable). */
      fade.style.opacity = String(opacity);
      fade.style.pointerEvents = 'none';

      /* Sheet-active only after dim delay; buy stays clickable via CSS. */
      sticky.classList.toggle('is-sheet-active', progress > 0.04);

      /* Header/menu/logo scroll away; restore only at page top */
      setHeaderOut(y > HEADER_TOP);
    }

    if (REDUCE) fade.style.transition = 'none';

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* —— Quantity —— */
  function initQty(root) {
    qsa(root, '[data-atelier-qty]').forEach(function (wrap) {
      if (wrap.getAttribute('data-qty-bound') === 'true') return;
      wrap.setAttribute('data-qty-bound', 'true');
      var input = qs(wrap, '[data-atelier-qty-input]');
      var dec = qs(wrap, '[data-atelier-qty-dec]');
      var inc = qs(wrap, '[data-atelier-qty-inc]');
      if (!input) return;

      function setVal(n) {
        n = Math.max(1, Math.min(99, n | 0));
        input.value = String(n);
      }

      if (dec) {
        dec.addEventListener('click', function (e) {
          e.preventDefault();
          setVal((parseInt(input.value, 10) || 1) - 1);
        });
      }
      if (inc) {
        inc.addEventListener('click', function (e) {
          e.preventDefault();
          setVal((parseInt(input.value, 10) || 1) + 1);
        });
      }
      input.addEventListener('change', function () {
        setVal(parseInt(input.value, 10) || 1);
      });
    });
  }

  /* —— Close spin helper —— */
  function bindCloseSpin(btn, onFinish) {
    if (!btn || btn.getAttribute('data-close-spin-bound') === 'true') return;
    btn.setAttribute('data-close-spin-bound', 'true');
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (btn.classList.contains('is-spinning')) return;
      var icon =
        btn.querySelector('.tambur-atelier-panel__close-icon') ||
        btn.querySelector('.tambur-atelier-store__close-icon') ||
        btn.querySelector('.tambur-product-drawer__close-icon') ||
        btn.querySelector('svg') ||
        btn.querySelector('[aria-hidden="true"]');
      if (!icon) {
        onFinish();
        return;
      }
      var finished = false;
      function finish() {
        if (finished) return;
        finished = true;
        icon.removeEventListener('animationend', finish);
        clearTimeout(fallback);
        btn.classList.remove('is-spinning');
        onFinish();
      }
      var fallback = setTimeout(finish, 450);
      btn.classList.remove('is-spinning');
      void btn.offsetWidth;
      btn.classList.add('is-spinning');
      icon.addEventListener('animationend', finish);
    });
  }

  /* —— Unified desktop panel —— */
  function initAtelierPanel(root) {
    var panel = qs(root, '[data-atelier-panel]');
    if (!panel || panel.getAttribute('data-atelier-panel-bound') === 'true') return;
    panel.setAttribute('data-atelier-panel-bound', 'true');

    var tabs = qsa(panel, '[data-atelier-panel-tab]');
    var panes = qsa(panel, '[data-atelier-panel-pane]');
    var indicator = qs(panel, '[data-atelier-panel-indicator]');
    var current = 0;
    var tabIds = ['specs', 'shipping', 'returns'];

    function setTab(index, animate) {
      index = Math.max(0, Math.min(tabs.length - 1, index));
      var from = current;
      var dirClass = from > index ? 'in-l' : 'in-r';
      var same = from === index;
      current = index;
      tabs.forEach(function (t, i) {
        t.classList.toggle('is-active', i === index);
        t.setAttribute('aria-selected', i === index ? 'true' : 'false');
      });
      if (indicator) {
        indicator.setAttribute('data-index', String(index));
        indicator.style.transform = 'translateX(' + index * 100 + '%)';
      }
      panes.forEach(function (pane, i) {
        pane.classList.remove('is-active', 'in-l', 'in-r');
        if (i === index) {
          if (animate && !same) {
            void pane.offsetWidth; /* restart keyframe */
            pane.classList.add('is-active', dirClass);
          } else {
            pane.classList.add('is-active');
          }
          pane.removeAttribute('hidden');
        } else {
          pane.setAttribute('hidden', '');
        }
      });
    }

    function openPanel(id) {
      var idx = tabIds.indexOf(id);
      if (idx < 0) idx = 0;
      /* Snap indicator without animating from previous tab (mockup openDrawer) */
      if (indicator) {
        indicator.style.transition = 'none';
        indicator.style.transform = 'translateX(' + idx * 100 + '%)';
        void indicator.offsetWidth;
        indicator.style.transition = '';
      }
      current = -1; /* force fresh show without slide-in on open */
      panel.classList.add('is-open');
      panel.setAttribute('aria-hidden', 'false');
      document.body.classList.add('tambur-product-panel-open');
      setTab(idx, false);
      /* Do not focus the sheet — avoids blue focus ring on first tab on mobile */
      var closeBtn = qs(panel, '[data-atelier-panel-close-btn]');
      if (closeBtn) {
        try { closeBtn.focus({ preventScroll: true }); } catch (err) { /* ignore */ }
      }
    }

    function closePanel() {
      panel.classList.remove('is-open');
      panel.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('tambur-product-panel-open');
      current = -1;
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () {
        if (i === current) return;
        setTab(i, true);
        tab.blur();
      });
    });

    qsa(root, '[data-product-panel-open]').forEach(function (btn) {
      if (btn.getAttribute('data-atelier-open-bound') === 'true') return;
      btn.setAttribute('data-atelier-open-bound', 'true');
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        openPanel(btn.getAttribute('data-product-panel-open') || 'specs');
      });
    });

    var closeBtn = qs(panel, '[data-atelier-panel-close-btn]');
    bindCloseSpin(closeBtn, closePanel);

    var scrim = qs(panel, '[data-atelier-panel-scrim]');
    if (scrim) {
      scrim.addEventListener('click', function () {
        closePanel();
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && panel.classList.contains('is-open')) closePanel();
    });

    setTab(0, false);
  }

  /* —— Mobile detail tabs —— */
  function initMobileTabs(root) {
    var nav = qs(root, '[data-atelier-mtabs]');
    if (!nav || nav.getAttribute('data-mtabs-bound') === 'true') return;
    nav.setAttribute('data-mtabs-bound', 'true');
    var buttons = qsa(nav, '[data-atelier-mtab]');
    var indicator = qs(nav, '[data-atelier-mtab-indicator]');
    var panesRoot = qs(root, '[data-atelier-mpanes]');
    if (!panesRoot) return;
    var panes = qsa(panesRoot, '[data-atelier-mpane]');
    var current = 0;

    function setTab(index) {
      index = Math.max(0, Math.min(buttons.length - 1, index));
      var dir = index > current ? 1 : index < current ? -1 : 0;
      current = index;
      buttons.forEach(function (b, i) {
        b.classList.toggle('is-active', i === index);
        b.setAttribute('aria-selected', i === index ? 'true' : 'false');
      });
      if (indicator) indicator.setAttribute('data-index', String(index));
      panes.forEach(function (pane, i) {
        pane.classList.remove('is-active', 'is-from-left', 'is-from-right');
        if (i === index) {
          if (dir > 0) pane.classList.add('is-from-right');
          else if (dir < 0) pane.classList.add('is-from-left');
          void pane.offsetWidth;
          pane.classList.add('is-active');
        }
      });
    }

    buttons.forEach(function (btn, i) {
      btn.addEventListener('click', function () {
        setTab(i);
        btn.blur();
      });
    });
    setTab(0);
  }

  /* —— Store hours (Europe/Stockholm) —— */
  function stockholmParts(date) {
    var fmt = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Stockholm',
      weekday: 'short',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    });
    var parts = fmt.formatToParts(date);
    var map = {};
    parts.forEach(function (p) {
      map[p.type] = p.value;
    });
    return map;
  }

  function storeOpenState(el) {
    if (!el) return;
    var openLabel = el.getAttribute('data-open-label') || 'Öppet nu · stänger';
    var closedLabel = el.getAttribute('data-closed-label') || 'Stängt just nu · öppnar';
    var now = new Date();
    var p = stockholmParts(now);
    var day = (p.weekday || '').slice(0, 3);
    var minutes = parseInt(p.hour, 10) * 60 + parseInt(p.minute, 10);
    var open = 11 * 60;
    var close = day === 'Sat' ? 17 * 60 : day === 'Sun' ? null : 18 * 60;

    if (close == null) {
      el.textContent = closedLabel + ' 11.00';
      return;
    }
    if (minutes >= open && minutes < close) {
      var ch = String(Math.floor(close / 60)).padStart(2, '0');
      var cm = String(close % 60).padStart(2, '0');
      el.textContent = openLabel + ' ' + ch + '.' + cm;
    } else {
      el.textContent = closedLabel + ' 11.00';
    }
  }

  function initStoreCard(root) {
    qsa(root, '[data-atelier-store-open-state]').forEach(storeOpenState);

    var store = qs(root, '[data-atelier-store]');
    if (!store) return;

    qsa(root, '[data-atelier-store-toggle]').forEach(function (btn) {
      if (btn.getAttribute('data-atelier-store-bound') === 'true') return;
      btn.setAttribute('data-atelier-store-bound', 'true');
      btn.addEventListener('click', function (e) {
        if (MQ.matches) {
          // Mobile: existing modal script handles [data-store-stock-toggle]
          return;
        }
        e.preventDefault();
        e.stopImmediatePropagation();
        var open = store.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      }, true);
    });

    var closeBtn = qs(store, '[data-atelier-store-close]');
    bindCloseSpin(closeBtn, function () {
      store.classList.remove('is-open');
      qsa(root, '[data-atelier-store-toggle]').forEach(function (b) {
        b.setAttribute('aria-expanded', 'false');
      });
    });

    // Mobile sheet close: spin then hide modal
    var modal = qs(root, '[data-store-stock-modal]');
    if (modal) {
      qsa(modal, '.tambur-footer-modal__close[data-store-stock-close], .tambur-atelier-store__close[data-store-stock-close]').forEach(function (btn) {
        bindCloseSpin(btn, function () {
          modal.hidden = true;
          document.body.classList.remove('tambur-store-modal-open');
          qsa(root, '[data-store-stock-toggle], [data-atelier-store-toggle]').forEach(function (b) {
            b.setAttribute('aria-expanded', 'false');
          });
        });
      });
    }

    document.addEventListener('click', function (e) {
      if (!store.classList.contains('is-open')) return;
      if (store.contains(e.target)) return;
      if (e.target.closest && e.target.closest('[data-atelier-store-toggle]')) return;
      store.classList.remove('is-open');
    });
  }

  function init(root) {
    var scope = root && root.querySelector ? root : document;
    var product = qs(scope, '.tambur-product--atelier');
    if (!product) return;
    document.body.classList.add('tambur-atelier-pdp');
    placeBuyBlock(product);
    lockPinOffset(product);
    initStickyFade(product);
    initQty(product);
    initAtelierPanel(product);
    initMobileTabs(product);
    initStoreCard(product);
  }

  init();
  /* Bilder ovanför remsan kan ändra höjden när de laddats – räkna om fästpunkten en gång till */
  window.addEventListener('load', function () {
    var product = document.querySelector('.tambur-product--atelier');
    if (product && product.querySelector('[data-serie-remsa]')) lockPinOffset(product);
  });
  window.addEventListener('resize', function () {
    var product = document.querySelector('.tambur-product--atelier');
    if (product) placeBuyBlock(product);
  });
  /* Orientation only — do not re-lock on URL-bar-driven resize (that was the jump). */
  window.addEventListener('orientationchange', function () {
    window.setTimeout(function () {
      var product = document.querySelector('.tambur-product--atelier');
      if (product) lockPinOffset(product);
    }, 120);
  });
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
